export default ({}) => ({
    yAxis: {
        startOnTick: false,
        endOnTick: false,
    },
});
